/**
 * RAIL GLYPHS — DP60 Part 0d/0e, narrowed by Part 0b Part 1.
 *
 * LETTERS APPLY TO THE SEVEN FIXED ROWS ONLY:
 *   MD My Desk · PR Projects · WT Work Table
 *   CN Connections · WS Workspace · RS Resources · OP Operations
 *
 * Every destination INSIDE a group uses its ICON — the same icon it shows in the
 * expanded rail. Derivation was tried and abandoned: it produced PR for both
 * Projects and Procurement and CO for both Contacts and Contractors, two letters
 * cannot separate those, and three letters break the tight box. So there is no
 * derivation any more. `glyphFor` returns null for anything outside the seven,
 * and a box with no glyph draws its icon.
 *
 * The seven are hand-picked and cannot collide; `findCollisions` proves it over
 * the seven rather than trusting it.
 *
 * LETTERS OR ICONS is a tenant setting read from company settings, field
 * `rail_glyph_mode`, values 'letters' | 'icons'. It governs THE SEVEN ONLY —
 * 'icons' makes those seven show their icons too; group destinations are icons
 * either way. DP61 owns the control on the Branding page. Missing, unreadable or
 * unrecognised => LETTERS.
 */
export const FIXED_GLYPHS = {
  mydesk: 'MD',
  projects: 'PR',
  worktable: 'WT',
  connections: 'CN',
  workspace: 'WS',
  resources: 'RS',
  operations: 'OP',
};

export const RAIL_GLYPH_FIELD = 'rail_glyph_mode';

export const railGlyphMode = (companySettings) => {
  const raw = companySettings && companySettings[RAIL_GLYPH_FIELD];
  return raw === 'icons' ? 'icons' : 'letters';
};

/** The seven, or null. Null means "draw your icon". */
export const glyphFor = (id) => FIXED_GLYPHS[id] || null;

/** [{ glyph, ids: [...], labels: [...] }] for every glyph used more than once. */
export const findCollisions = (entries) => {
  const byGlyph = {};
  for (const e of entries) {
    const g = glyphFor(e.id);
    if (!g) continue;
    (byGlyph[g] ||= []).push(e);
  }
  return Object.entries(byGlyph)
    .filter(([, uses]) => uses.length > 1)
    .map(([glyph, uses]) => ({
      glyph,
      ids: uses.map((u) => u.id),
      labels: uses.map((u) => u.label),
    }));
};
